import { useEffect } from "react"
import { useState } from "react"
import { Link } from "react-router-dom"
import { AdminFooter } from "../../components/adminFooter/adminFooter.component"
import { Pagination } from "../../components/pagination/pagination.component"
import { UserListCard } from "../../components/userListCard/userListCard.component"
import { getAdminUsers } from "../../services/admin.service"

export const UserList = () => {
    const [userList, setUserList] = useState([])

    const [currentPage, setCurrentPage] = useState(1)

    const [userListPerPage, setJuryListPerPage] = useState(10)

    const changePage = pageNumber => setCurrentPage(pageNumber)

    const getUserList = async () => {
        const { status, data } = await getAdminUsers()
        if (status == 200) {
            setUserList(data)
        }
    }
    useEffect(() => {
        getUserList()
    }, [])

    const indexOfLastUser = currentPage * userListPerPage
    const indexOfFirstUser = indexOfLastUser - userListPerPage
    const currenUserList = userList.slice(indexOfFirstUser, indexOfLastUser)

    return (
        <div className="app-content content">
            <div className="content-overlay" />
            <div className="header-navbar-shadow" />
            <div className="content-wrapper">
                <div className="content-body">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <h2 className="mb-0">USERS MANAGEMENT</h2>
                            <p className="font-lato font-12">{userList.length} records</p>
                        </div>
                        <div className="col-lg-6 col-12 text-right">
                            <Link
                                to="/users/add-user"
                                className="btn btn-primary font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                            >
                                <i className="fas fa-plus mr-1" />
                                Add new
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table idea-table font-lato font-12">
                                    <tbody>

                                        {currenUserList.map((user, index) => {
                                            return <UserListCard key={index} id={user.ID} name={user.EMP_NAME} email={user.EMAIL} mobile={user.EMP_MOBILE} role={user.EMP_TYPE == 101 ? "Admin" : "Moderator"} isActive={user.IS_ACTIVE} createdDate={user.createAt} />
                                        })}

                                    </tbody>
                                </table>
                            </div>
                            <Pagination itemsPerPage={userListPerPage} totalItems={userList.length} changePage={changePage} currentPage={currentPage} />
                        </div>
                    </div>
                    <AdminFooter />
                </div>
            </div>
        </div>

    )
}